/**
 * Compendium of decline codes from Stripe Docs (https://stripe.com/docs/declines/codes) along with
 * humanized responses for error messaging.
 *
 * If an error stems from understandable human error (ie. incorrect CC number, CVC, Billing Address), we prompt the user to attempt the transaction again.
 * If the error stems from a banking issue, (ie. insufficient funds, stolen card etc.), we prompt the user to contact their CC provider.
 */

export const tryAgainErrors = [
  'approve_with_id',
  'incorrect_number',
  'incorrect_cvc',
  'incorrect_zip',
  'invalid_cvc',
  'invalid_expiry_month',
  'invalid_expiry_year',
  'invalid_number',
  'issuer_not_available',
  'processing_error',
  'reenter_transaction',
  'try_again_later',
];

export const regionsListCAN = [
  { value: 'Alberta', code: 'AL' },
  { value: 'British Columbia', code: 'BC' },
  { value: 'Manitoba', code: 'MB' },
  { value: 'New Brunswick', code: 'NB' },
  { value: 'Newfoundland and Labrador', code: 'NL' },
  { value: 'Nova Scotia', code: 'NS' },
  { value: 'Northwest Territories', code: 'NT' },
  { value: 'Nunavut', code: 'NU' },
  { value: 'Ontario', code: 'ON' },
  { value: 'Prince Edward Island', code: 'PE' },
  { value: 'Quebec', code: 'QC' },
  { value: 'Saskatchewan', code: 'SK' },
  { value: 'Yukon', code: 'TY' },
];

export const stateAbrvList = [
  'AL',
  'AK',
  'AS',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FM',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MH',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'MP',
  'OH',
  'OK',
  'OR',
  'PW',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VI',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

export const productTypeImgMapping = {
  'TrueBearing Standard': 'trueBearing',
  NMI: 'trueBearing',
  'TrueBearing Training': 'training',
  TheraQPlus: 'theraq',
  TrueBearingTraining: 'fastlane',
};
